import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import ProjectDetails from "@/features/projects/project/details";

export const Route = createFileRoute(
  "/_auth/_app-shell/projects/$projectId/edit",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ProjectDetails />
    </Suspense>
  );
}
